import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  height: "800",
  width: "800",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 485.231 485.231",
  "xml:space": "preserve"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M440.831 176.681h-252c-24.4 0-44.4 20-44.4 44.4v159.6c0 24.4 20 44.4 44.4 44.4h252c24.4 0 44.4-20 44.4-44.4v-159.6c.1-24.5-20-44.4-44.4-44.4zm20.5 204.6c0 8.8-7.2 16.1-16.1 16.1h-256.9c-8.8 0-16.1-7.2-16.1-16.1v-112.3h289.1v112.3zm0-154.6h-289.1v-6.1c0-8.8 7.2-16.1 16.1-16.1h256.9c8.8 0 16.1 7.2 16.1 16.1v6.1z" }, null, -1),
    _createElementVNode("path", { d: "M185.631 149.281h156.3l-31.8-64.4c-10.9-22-37.6-31-59.6-20.1l-225.8 111.6c-22 10.9-31 37.6-20.1 59.6l70.8 143.1c9.5 19.3 31.4 28.7 51.5 23.2-6-10.1-9.4-21.8-9.4-34.3v-150.5c-.1-37.5 30.6-68.2 68.1-68.2z" }, null, -1)
  ]))]))
}
export default { render: render }